export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 80,
            staffing: 0.1,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 240,
            staffing:0.4,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 480,
            staffing: 0.7,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Small",
                    description: "Loading door",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "1 Dock",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "2 Docks",
                    value: 3
                }
            ]
        }

    ]
}
